import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { buttonSizeToHeight } from '../Button';
import { IconButton } from '../IconButton/IconButton';
export const Button = styled(IconButton) `
  position: static;
  border-radius: 50%;
  background-color: ${o => o.theme.color.fill.subtle};
  pointer-events: all;
  box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.1);
  z-index: 101;
`;
export const StyledMuteButton = styled(Button) `
  right: 40px;
  height: ${o => buttonSizeToHeight(o.size ?? 'medium')};
  width: ${o => buttonSizeToHeight(o.size ?? 'medium')};
`;
export const PauseWrapper = styled.div `
  display: flex;
  gap: 3px;
  max-width: 24px;
  max-height: 24px;
  position: relative;
`;
export const PauseLine = styled.div `
  width: 2px;
  height: 13px;
  background-color: ${o => o.theme.color.stroke.neutral.border.interaction.primary.on.background};
  border-radius: 1px;
`;
export const PauseIcon = () => (_jsxs(PauseWrapper, { children: [_jsx(PauseLine, {}), _jsx(PauseLine, {})] }));
export const PlayIcon = styled.div `
  background: transparent;
  height: 34px;
  min-width: 34px;
  position: absolute;

  &::after {
    content: '';
    display: block;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 8px solid
      ${o => o.theme.color.stroke.neutral.border.interaction.primary.on.background};
    height: 0;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-36%, -50%);
    width: 0;
  }
`;
//# sourceMappingURL=styles.js.map